import StoredViews from './StoredViews';

export default StoredViews;
